import {
  ChangeDetectionStrategy, Component, ElementRef, inject, input, NgZone, output, viewChild,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';
import { SablonRendererComponent } from '../sablon-renderer/sablon-renderer.component';
import { ISablon, ISablonElement } from '../sablon-editoru/sablon.interface';

@Component({
  selector: 'te-canvas',
  standalone: true,
  imports: [CommonModule, NzIconModule, NzTooltipModule, SablonRendererComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="tc-wrapper">
      @if (seciliElementId()) {
        <div class="tc-arac-cubugu">
          <button (click)="hizala('sol')" nz-tooltip nzTooltipTitle="Sola hizala">
            <span nz-icon nzType="align-left" nzTheme="outline"></span>
          </button>
          <button (click)="hizala('sag')" nz-tooltip nzTooltipTitle="Sağa hizala">
            <span nz-icon nzType="align-right" nzTheme="outline"></span>
          </button>
          <button (click)="hizala('ust')" nz-tooltip nzTooltipTitle="Üste hizala">
            <span nz-icon nzType="vertical-align-top" nzTheme="outline"></span>
          </button>
          <button (click)="hizala('alt')" nz-tooltip nzTooltipTitle="Alta hizala">
            <span nz-icon nzType="vertical-align-bottom" nzTheme="outline"></span>
          </button>
          <span class="tc-ayirici">|</span>
          <button (click)="seciliSil()" nz-tooltip nzTooltipTitle="Sil">
            <span nz-icon nzType="delete" nzTheme="outline"></span>
          </button>
          <button (click)="kopyala()" nz-tooltip nzTooltipTitle="Kopyala">
            <span nz-icon nzType="copy" nzTheme="outline"></span>
          </button>
        </div>
      }

      <div class="tc-canvas" #canvasRef [style.aspect-ratio]="sablonOrani()" (click)="canvasTiklandi($event)">
        <sablon-renderer
          [sablon]="sablon()"
          [parametreDegerleri]="parametreDegerleri()">
        </sablon-renderer>

        <div class="tc-drag-overlay">
          @for (el of sablon()?.elementler; track el.id) {
            <div class="tc-drag-handle"
              [attr.data-id]="el.id"
              [class.secili]="el.id === seciliElementId()"
              [style.left.%]="el.x"
              [style.top.%]="el.y"
              [style.width.%]="elGenislikYuzde(el)"
              [style.height.%]="elYukseklikYuzde(el)"
              (mousedown)="dragBasla($event, el)"
              (click)="elementTiklandi($event, el.id)">

              @if (el.id === seciliElementId()) {
                <div class="tc-resize-handle nw" (mousedown)="resizeBasla($event, el, 'nw')"></div>
                <div class="tc-resize-handle ne" (mousedown)="resizeBasla($event, el, 'ne')"></div>
                <div class="tc-resize-handle sw" (mousedown)="resizeBasla($event, el, 'sw')"></div>
                <div class="tc-resize-handle se" (mousedown)="resizeBasla($event, el, 'se')"></div>
              }
            </div>
          }
        </div>
      </div>
    </div>
  `,
  styles: `
    :host { display: flex; flex: 1; position: relative; overflow: hidden; }

    .tc-wrapper {
      flex: 1; display: flex; flex-direction: column; align-items: center;
      justify-content: center; background: var(--te-canvas-bg, rgba(0,0,0,0.04)); position: relative;
      padding: 16px;
    }

    .tc-arac-cubugu {
      position: absolute; top: 8px; left: 50%; transform: translateX(-50%);
      display: flex; gap: 4px; align-items: center;
      background: var(--te-toolbar-bg, #fff); padding: 4px 8px;
      box-shadow: 0 2px 8px rgba(0,0,0,0.12); border: 1px solid var(--te-toolbar-border, rgba(0,0,0,0.06));
      border-radius: 6px; font-size: 14px; z-index: 10;
      button {
        background: none; border: none; color: var(--te-toolbar-btn, rgba(0,0,0,0.55));
        cursor: pointer; padding: 4px 6px; display: inline-flex; align-items: center;
        border-radius: 4px; transition: all 0.15s;
        &:hover { color: var(--te-toolbar-btn-hover, rgba(0,0,0,0.85)); background: var(--te-hover, rgba(0,0,0,0.06)); }
      }
      .tc-ayirici { color: var(--te-text-muted, rgba(0,0,0,0.15)); margin: 0 2px; }
    }

    .tc-canvas {
      position: relative; width: 100%;
      aspect-ratio: 520 / 300;
      border-radius: 8px; overflow: visible;
    }

    sablon-renderer { position: absolute; inset: 0; z-index: 1; }

    .tc-drag-overlay { position: absolute; inset: 0; z-index: 5; pointer-events: none; }

    .tc-drag-handle {
      position: absolute; cursor: move; border: 1px dashed transparent; pointer-events: auto;
      transition: border-color 0.15s;
      &:hover { border-color: rgba(24,144,255,0.4); }
      &.secili { border: 2px solid #1890ff; }
    }

    .tc-resize-handle {
      position: absolute; width: 8px; height: 8px; background: #1890ff; border-radius: 1px;
      &.nw { top: -4px; left: -4px; cursor: nw-resize; }
      &.ne { top: -4px; right: -4px; cursor: ne-resize; }
      &.sw { bottom: -4px; left: -4px; cursor: sw-resize; }
      &.se { bottom: -4px; right: -4px; cursor: se-resize; }
    }

    :host-context(body.tema-karanlik) {
      --te-canvas-bg: rgba(0,0,0,0.2);
      --te-toolbar-bg: rgba(30,30,30,0.95);
      --te-toolbar-border: rgba(255,255,255,0.08);
      --te-toolbar-btn: rgba(255,255,255,0.6);
      --te-toolbar-btn-hover: #fff;
      --te-hover: rgba(255,255,255,0.1);
      --te-text-muted: rgba(255,255,255,0.15);
    }
  `,
})
export class TeCanvasComponent {
  private ngZone = inject(NgZone);
  private elRef = inject(ElementRef);
  private canvasRef = viewChild<ElementRef>('canvasRef');

  sablon = input<ISablon>();
  seciliElementId = input<string | null>(null);
  parametreDegerleri = input<Record<string, any>>({});

  elementSecildi = output<string | null>();
  elementGuncellendi = output<{ id: string; patch: Partial<ISablonElement> }>();
  elementSilindi = output<string>();
  sablonGuncellendi = output<Partial<ISablon>>();

  sablonOrani(): string {
    const s = this.sablon();
    return (s?.genislik || 520) + " / " + (s?.yukseklik || 300);
  }

  elGenislikYuzde(el: ISablonElement): number {
    const s = this.sablon();
    return (el.genislik / (s?.genislik || 520)) * 100;
  }

  elYukseklikYuzde(el: ISablonElement): number {
    const s = this.sablon();
    return (el.yukseklik / (s?.yukseklik || 300)) * 100;
  }

  dragBasla(event: MouseEvent, element: ISablonElement) {
    event.stopPropagation();
    this.elementSecildi.emit(element.id);

    const canvasRect = this.canvasRef()?.nativeElement?.getBoundingClientRect();
    if (!canvasRect) return;

    const startX = event.clientX;
    const startY = event.clientY;
    const origX = element.x || 0;
    const origY = element.y || 0;

    this.ngZone.runOutsideAngular(() => {
      let rafId = 0;
      let newX = origX, newY = origY;
      const elGenPct = this.elGenislikYuzde(element);
      const elYukPct = this.elYukseklikYuzde(element);

      const onMove = (e: MouseEvent) => {
        const dx = ((e.clientX - startX) / canvasRect.width) * 100;
        const dy = ((e.clientY - startY) / canvasRect.height) * 100;
        newX = Math.max(0, Math.min(100 - elGenPct, origX + dx));
        newY = Math.max(0, Math.min(100 - elYukPct, origY + dy));
        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          const handle = this.elRef.nativeElement.querySelector(`[data-id="${element.id}"]`);
          if (handle) { handle.style.left = newX + '%'; handle.style.top = newY + '%'; }
        });
      };

      const onUp = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        cancelAnimationFrame(rafId);
        this.ngZone.run(() => {
          this.elementGuncellendi.emit({
            id: element.id,
            patch: { x: Math.round(newX * 10) / 10, y: Math.round(newY * 10) / 10 },
          });
        });
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
  }

  resizeBasla(event: MouseEvent, element: ISablonElement, kose: string) {
    event.stopPropagation();
    event.preventDefault();

    const canvasRect = this.canvasRef()?.nativeElement?.getBoundingClientRect();
    if (!canvasRect) return;

    const s = this.sablon();
    const sW = s?.genislik || 520;
    const sH = s?.yukseklik || 300;
    const startX = event.clientX;
    const startY = event.clientY;
    const origX = element.x || 0;
    const origY = element.y || 0;
    const origW = this.elGenislikYuzde(element);
    const origH = this.elYukseklikYuzde(element);
    const origWpx = element.genislik;
    const origHpx = element.yukseklik;

    this.ngZone.runOutsideAngular(() => {
      let rafId = 0;
      let curX = origX, curY = origY, curW = origW, curH = origH;
      let pxW = origWpx, pxH = origHpx;

      const onMove = (e: MouseEvent) => {
        const dxPct = ((e.clientX - startX) / canvasRect.width) * 100;
        const dyPct = ((e.clientY - startY) / canvasRect.height) * 100;

        curX = origX; curY = origY; curW = origW; curH = origH;

        if (kose.includes('e')) curW = Math.max(2, origW + dxPct);
        if (kose.includes('w')) { curW = Math.max(2, origW - dxPct); curX = origX + dxPct; }
        if (kose.includes('s')) curH = Math.max(2, origH + dyPct);
        if (kose.includes('n')) { curH = Math.max(2, origH - dyPct); curY = origY + dyPct; }

        pxW = Math.max(10, Math.round((curW / 100) * sW));
        pxH = Math.max(10, Math.round((curH / 100) * sH));

        cancelAnimationFrame(rafId);
        rafId = requestAnimationFrame(() => {
          const handle = this.elRef.nativeElement.querySelector(`[data-id="${element.id}"]`);
          if (handle) {
            handle.style.left = curX + '%';
            handle.style.top = curY + '%';
            handle.style.width = curW + '%';
            handle.style.height = curH + '%';
          }
        });
      };

      const onUp = () => {
        document.removeEventListener('mousemove', onMove);
        document.removeEventListener('mouseup', onUp);
        cancelAnimationFrame(rafId);
        this.ngZone.run(() => {
          this.elementGuncellendi.emit({
            id: element.id,
            patch: {
              x: Math.round(curX * 10) / 10,
              y: Math.round(curY * 10) / 10,
              genislik: pxW,
              yukseklik: pxH,
            },
          });
        });
      };

      document.addEventListener('mousemove', onMove);
      document.addEventListener('mouseup', onUp);
    });
  }

  canvasTiklandi(event: MouseEvent) {
    const target = event.target as HTMLElement;
    if (target.classList.contains('tc-drag-overlay') || target.classList.contains('tc-canvas')) {
      this.elementSecildi.emit(null);
    }
  }

  elementTiklandi(event: MouseEvent, id: string) {
    event.stopPropagation();
    this.elementSecildi.emit(id);
  }

  seciliSil() {
    const id = this.seciliElementId();
    if (id) this.elementSilindi.emit(id);
  }

  kopyala() {
    const el = this.sablon()?.elementler?.find(e => e.id === this.seciliElementId());
    if (!el) return;
    const klon: ISablonElement = {
      ...el,
      id: crypto.randomUUID?.() || Date.now().toString(),
      x: (el.x || 0) + 5,
      y: (el.y || 0) + 5,
    };
    this.sablonGuncellendi.emit({ elementler: [...(this.sablon()?.elementler || []), klon] });
  }

  hizala(yon: 'sol' | 'sag' | 'ust' | 'alt') {
    const id = this.seciliElementId();
    if (!id) return;
    const el = this.sablon()?.elementler?.find(e => e.id === id);
    if (!el) return;
    const patch: Partial<ISablonElement> = {};
    switch (yon) {
      case 'sol': patch.x = 0; break;
      case 'sag': patch.x = 100 - this.elGenislikYuzde(el); break;
      case 'ust': patch.y = 0; break;
      case 'alt': patch.y = 100 - this.elYukseklikYuzde(el); break;
    }
    this.elementGuncellendi.emit({ id, patch });
  }
}
